<template>
    <div>
        <v-card-title>
            Benutzerberechtigungen verwalten
        </v-card-title>
        <v-btn @click="addNew()" color="primary" class="mx-5 mb-5"
                :disabled="!adminUser || !adminUser.permissions.userAdmin">
            <v-icon class="mr-2">mdi-plus</v-icon>
            Neuen Benutzer anlegen
        </v-btn>
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"
                      label="Suchen" filled dense single-line hide-details class="mb-3 mx-5">
            <template v-slot:append>
                <v-btn icon small class="pb-2">
                    <v-icon style="cursor: pointer" @click="search=''">mdi-close</v-icon>
                </v-btn>
            </template>
        </v-text-field>
        <v-radio-group v-model="archived" row class="mx-5">
            <v-radio label="nur aktive Benutzer" :value="false"></v-radio>
            <v-radio label="nur archivierte Benutzer" :value="true"></v-radio>
        </v-radio-group>
        <v-data-table :headers="headers" :items="users"
                      :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                      hide-default-footer class="mx-5" mobile-breakpoint="1"
                      :search="search" dense disable-pagination>
            <template v-slot:item.permissionText="{ item }">
                <user-admin-roles :userItem="item"
                                  @editUserRoles="editItem({item: item, action: 'editUserRoles'})">
                </user-admin-roles>
            </template>
            <template v-slot:item.ts="{ item }">
                {{getTimeStamp(item.ts)}}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn icon @click="editItem({item: item, action: 'editUser'})"><v-icon>mdi-pencil</v-icon></v-btn>
            </template>
            <template v-slot:item.createdByNoSearch="{ item }">
                {{item.createdBy}}
            </template>
        </v-data-table>
        <user-admin-edit v-if="$route.query.action==='editUser'"
                            :currentObject="currentObject">
        </user-admin-edit>
        <user-admin-edit-roles v-if="$route.query.action==='editUserRoles'"
                            :currentObject="currentObject">
        </user-admin-edit-roles>
        <v-btn fab dark bottom right color="primary" @click="back()"
               style="position: fixed; right: 15px; bottom: 15px; z-index: 15" >
            <v-icon >mdi-arrow-left</v-icon>
        </v-btn>
    </div>
</template>

<script>
    import UserAdminRoles from "./userAdminRoles";
    import UserAdminEdit from "./userAdminEdit";
    import TimeStamp from "../../services/timeStamp"
    import UserAdminEditRoles from "./userAdminEditRoles";

    export default {
        components: {
            UserAdminEditRoles,
            UserAdminEdit,
            UserAdminRoles},
        name: "user-admin",
        computed: {
            users(){return this.$store.state.realtime.users
                .filter(user => this.archived ? user.archived : !user.archived)
                .map(user => ({ ...user,
                permissionText: JSON.stringify(user.permissions), id: user.id }));},
            adminUser(){
                return this.$store.state.user;
            },
        },
        data: () => ({
            sortBy: 'ts',
            sortDesc: true,
            headers: [
                { text: 'Vorname', value: 'firstName'},
                { text: 'Nachname', value: 'lastName'},
                { text: 'eMail', value: 'email'},
                { text: 'Berechtigungen', value: 'permissionText'},
                { text: 'Erstellt am', value: 'ts'},
                { text: 'Erstellt von', value: 'createdByNoSearch', sortable: false},
                { text: 'Ändern', value: 'actions', sortable: false},
            ],
            search: null,
            currentObject: null,
            archived: false,
        }),
        created(){
            if ( this.users.length === 0 ) { this.bindUsers(); }
        },
        methods: {
            getTimeStamp(ts){
                return ts && ts>0 ? TimeStamp.getLocalDateAndTime(ts) : '';
            },
            bindUsers(){
                this.$store.dispatch('bindFullRealtimeList', {
                    collection: 'users',
                    storeField: 'users',
                });
            },
            back(){
                window.history.back();
            },
            addNew(){
                this.currentObject = null;
                this.openEdit('editUser');
            },
            editItem( parameter ){
                console.log ("item", parameter.item);
                this.currentObject = JSON.parse(JSON.stringify(parameter.item));
                this.currentObject.id = parameter.item.id;
                this.openEdit(parameter.action)
            },
            openEdit(action){
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = action;
                this.$router.push({path: p, query: q});
            }
        },
        watch: {
            users: {
                handler(){
                    this.$store.state.local.loader = false;
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>